'use strict';
import { Injectable } from "@angular/core";
import * as JSZip from 'jszip';
import { saveAs } from 'file-saver';

@Injectable()
export class JSZipProvider {

    constructor() { }

    async downloadAllAttachments(links, zipName) {
        let jszip: JSZip = new JSZip();
        for(let link of links) {
            const filename = link.split("/").pop();
            const responseFile = await fetch(link);
            const blobFile = await responseFile.blob();
            jszip.file(filename, blobFile);
        }

        jszip.generateAsync({ type: "blob" }).then(content => {
            saveAs(content, `${zipName}.zip`);
        });
    }

    async newDownloadAllAttachments(attachments: { name: string, url: string }[], zipName: string) {
        const jszip = new JSZip();

        for (const attachment of attachments) {
            const response = await fetch(attachment.url);
            const blob = await response.blob();
            jszip.file(attachment.name, blob);
        }

        const content = await jszip.generateAsync({ type: "blob" });
        saveAs(content, `${zipName}.zip`);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/providers/jszip.provider.ts